import { Box, FormControl, IconButton, TextField, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledInputLabel } from '../../../../../components/inputs/InputLabel';
import { StyledQuestionMark } from '../../../../../components/QuestionMark';
import { AccessibleAutocomplete } from '../../../../../components/inputs/AccessibleAutocomplete';

type PublisherFieldProps = {
  value: string;
  publishers: string[];
  disabled?: boolean;
  onChange: (value: string | null) => void;
};

export const PublisherField = ({
  value,
  publishers,
  disabled = false,
  onChange,
}: PublisherFieldProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <StyledInputLabel id="publisher-label" htmlFor="publisher">
          {t('agreements.publisher')} <span aria-hidden="true">*</span>
        </StyledInputLabel>
        <Tooltip title={t('agreements.tooltips.publisher')} placement="top">
          <IconButton size="small" sx={{ marginLeft: '3px' }}>
            <StyledQuestionMark fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <FormControl sx={{ width: '100%' }}>
        <AccessibleAutocomplete
          id="publisher"
          options={publishers.sort()}
          renderInput={(params) => (
            <TextField
              {...params}
              inputProps={{
                ...params.inputProps,
                required: true,
                'aria-labelledby': 'publisher-label',
              }}
            />
          )}
          sx={{ width: '100%' }}
          value={value || null}
          onChange={(e, v) => onChange(v)}
          disabled={disabled}
          isOptionEqualToValue={(option, value) =>
            option === value || value === ''
          }
        />
      </FormControl>
    </>
  );
};
